import template from './foodBenefitDelegations.html';
import controller from './foodBenefitDelegations.controller';
import './foodBenefitDelegations.scss';

let foodBenefitDelegationsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default foodBenefitDelegationsComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/features/foodBenefitDelegations/foodBenefitDelegations.component.js